import React from 'react';
import Grid from '@mui/material/Grid';
import {Box } from '@mui/material';

//This is a LayoutWrapper component. It takes care of the layout of the page with respect to the screen size.
//On big screens, the center 4/12 columns are used. 
//On middle screens, the center 6/12 columns are used.
//On small screens, the center 12/12 columns are used.

export default function LayoutWrapper(props) {
    const md = props.small ? 6 : 12
    const xl = props.small ? 4 : 6
    
    return (
        <Box display="flex" justifyContent="center" alignItems="center" width="100vw">
            <Grid container justifyContent="center" m={2}>
                <Grid item xs={12} md={md} xl={xl} style={{ marginBottom: 'auto' }}>
                    {props.children}
                </Grid>
            </Grid>
        </Box>
    );
}
